import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Fireflies = (props: TIconProps): ReactElement => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.22858 0.980347H0V8.16964H7.22858V0.980347Z"
      fill="url(#fireflies_paint0_linear_1790_106862)"
    />
    <path
      d="M15.7928 9.6626H8.56421V16.8519H15.7928V9.6626Z"
      fill="url(#fireflies_paint1_linear_1790_106862)"
    />
    <path
      d="M15.7928 0.980347H8.56421V8.16964H21.9999V7.14821C21.9999 5.49821 21.3321 3.96606 20.1928 2.78749C19.0142 1.6482 17.4428 0.980347 15.7928 0.980347Z"
      fill="url(#fireflies_paint2_linear_1790_106862)"
    />
    <path
      d="M0 9.6626V16.8519C0 18.5019 0.667858 20.034 1.80715 21.2126C2.98572 22.3519 4.55715 23.0198 6.20715 23.0198H7.22858V9.6626H0Z"
      fill="url(#fireflies_paint3_linear_1790_106862)"
    />
    <path
      opacity="0.18"
      d="M0 0.980347L7.22858 8.16964H0V0.980347Z"
      fill="url(#fireflies_paint4_linear_1790_106862)"
    />
    <path
      opacity="0.18"
      d="M8.56421 9.6626L15.7928 16.8519H8.56421V9.6626Z"
      fill="url(#fireflies_paint5_linear_1790_106862)"
    />
    <path
      opacity="0.18"
      d="M0 16.8126C0 18.4626 0.667858 19.9948 1.80715 21.1733C2.98572 22.3126 4.55715 22.9805 6.20715 22.9805H7.22858V9.6626L0 16.8126Z"
      fill="url(#fireflies_paint6_linear_1790_106862)"
    />
    <path
      opacity="0.18"
      d="M15.7928 0.980347C17.4428 0.980347 19.0142 1.6482 20.1928 2.78749C21.3714 3.92678 21.9999 5.49821 21.9999 7.14821V8.16964H8.56421L15.7928 0.980347Z"
      fill="url(#fireflies_paint7_linear_1790_106862)"
    />
    <defs>
      <linearGradient
        id="fireflies_paint0_linear_1790_106862"
        x1="17.5815"
        y1="19.2434"
        x2="-12.8185"
        y2="-12.6973"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 48%)" />
        <stop offset="0.113" stopColor="hsl(from hsl(231 44% 56%) h s 48%)" />
        <stop offset="0.3" stopColor="hsl(from hsl(231 44% 56%) h s 48%)" />
        <stop offset="0.54" stopColor="hsl(from hsl(231 44% 56%) h s 48%)" />
        <stop offset="0.818" stopColor="hsl(from hsl(231 44% 56%) h s 48%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 48%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint1_linear_1790_106862"
        x1="17.7505"
        y1="19.0853"
        x2="-12.6496"
        y2="-12.8553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 54%)" />
        <stop offset="0.103" stopColor="hsl(from hsl(231 44% 56%) h s 54%)" />
        <stop offset="0.274" stopColor="hsl(from hsl(231 44% 56%) h s 54%)" />
        <stop offset="0.492" stopColor="hsl(from hsl(231 44% 56%) h s 54%)" />
        <stop offset="0.745" stopColor="hsl(from hsl(231 44% 56%) h s 49%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 49%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint2_linear_1790_106862"
        x1="17.6145"
        y1="15.6819"
        x2="7.31377"
        y2="-21.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.113" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.3" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.54" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.818" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 62%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint3_linear_1790_106862"
        x1="14.268"
        y1="18.7549"
        x2="-22.6073"
        y2="7.52078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 45%)" />
        <stop offset="0.113" stopColor="hsl(from hsl(231 44% 56%) h s 45%)" />
        <stop offset="0.3" stopColor="hsl(from hsl(231 44% 56%) h s 45%)" />
        <stop offset="0.54" stopColor="hsl(from hsl(231 44% 56%) h s 45%)" />
        <stop offset="0.818" stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 62%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint4_linear_1790_106862"
        x1="-3.44874"
        y1="-8.02655"
        x2="6.88036"
        y2="15.6413"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 38%)" />
        <stop offset="0.114" stopColor="hsl(from hsl(231 44% 56%) h s 38%)" />
        <stop offset="0.303" stopColor="hsl(from hsl(231 44% 56%) h s 38%)" />
        <stop offset="0.544" stopColor="hsl(from hsl(231 44% 56%) h s 38%)" />
        <stop offset="0.825" stopColor="hsl(from hsl(231 44% 56%) h s 38%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 38%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint5_linear_1790_106862"
        x1="5.11944"
        y1="0.640276"
        x2="15.4485"
        y2="24.3081"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 54%)" />
        <stop offset="0.114" stopColor="hsl(from hsl(231 44% 56%) h s 51%)" />
        <stop offset="0.303" stopColor="hsl(from hsl(231 44% 56%) h s 45%)" />
        <stop offset="0.544" stopColor="hsl(from hsl(231 44% 56%) h s 35%)" />
        <stop offset="0.825" stopColor="hsl(from hsl(231 44% 56%) h s 22%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 14%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint6_linear_1790_106862"
        x1="-7.27948"
        y1="7.64109"
        x2="16.1135"
        y2="23.1817"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
        <stop offset="0.114" stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
        <stop offset="0.303" stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
        <stop offset="0.544" stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
        <stop offset="0.825" stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 50%)" />
      </linearGradient>
      <linearGradient
        id="fireflies_paint7_linear_1790_106862"
        x1="69.1081"
        y1="432.433"
        x2="73.1165"
        y2="464.081"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.114" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.303" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.544" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.825" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
        <stop offset="0.994" stopColor="hsl(from hsl(231 44% 56%) h s 47%)" />
      </linearGradient>
    </defs>
  </svg>
);
